import { createTheme } from "@mui/material";

export default createTheme({
    components: {
        MuiInputBase: {
            styleOverrides: {
                root: {
                    fontSize: '0.65rem',
                },
                input: {
                    padding: '6px 10px 7px'
                }
            }
        },
        MuiMenuItem: {
            styleOverrides: {
                root: {
                    fontSize: '0.8rem',
                    padding: '0px 0px 0px 10px',
                }
            }
        },
        MuiIconButton: {
            styleOverrides: {
                root: {
                    color: '#267db7',
                    outline: '0px !important'
                }
            }
        },
        MuiTab: {
            styleOverrides: {
                textColorPrimary: {
                    opacity: 0.7
                },
                textColorInherit: {
                    opacity: 1
                }
            }
        },
        MuiSvgIcon: {
            styleOverrides: {
                fontSizeSmall: {
                    fontSize: '1.05rem'
                },
                colorError: {
                    color: "#eb0a1e"
                }
            }
        },
        MuiButton: {
            styleOverrides: {
                containedPrimary: {
                    backgroundColor: "#303f9f",
                    '&:hover': {
                        backgroundColor: "#303f9f",
                    }
                }
            }
        }
    }
});
